import { useMemo } from "react";
import { Sparkles, Wand2 } from "lucide-react";

const DEFAULT_PROMPTS = [
  "Quais skills existem para desenvolvimento frontend?",
  "Como funciona o pipeline RAG do Mentor?",
  "Quais sao as melhores praticas de seguranca?",
  "Resuma as skills de negocios e marca",
];

const PROJECT_PROMPTS: Record<string, string[]> = {
  "~/Projetos/licitabot": [
    "Analise o pipeline RAG do LicitaBot",
    "Quais skills usar para auditoria de seguranca?",
    "Como funciona o feature gating?",
    "Revise o design system Nature Eco Green",
  ],
  "~/newortho": [
    "Audite a acessibilidade do site",
    "Quais skills para animacoes 3D?",
    "Como funciona o chatbot NewOrtho?",
    "Revise os depth tiers oklch",
  ],
  "~/Skills-dax": [
    "Quantas skills existem e por categoria?",
    "Como criar uma nova skill?",
    "Audite a cobertura de testes",
    "Quais skills para design de marca?",
  ],
};

export function getProjectPrompts(): string[] {
  try {
    const project = localStorage.getItem("mentor-selected-project") ?? "";
    if (project) {
      for (const [key, prompts] of Object.entries(PROJECT_PROMPTS)) {
        if (project.includes(key) || key.includes(project)) {
          return prompts;
        }
      }
    }
  } catch {
    // localStorage unavailable (SSR or private browsing)
  }
  return DEFAULT_PROMPTS;
}

interface QuickPromptsProps {
  onSelect: (prompt: string) => void;
  onRefine?: (prompt: string) => void;
}

export function QuickPrompts({ onSelect, onRefine }: QuickPromptsProps) {
  const prompts = useMemo(() => getProjectPrompts(), []);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Sparkles className="h-5 w-5" />
        <span className="emboss-2l text-sm font-medium">Como posso ajudar?</span>
      </div>
      <div className="grid w-full max-w-md grid-cols-2 gap-2">
        {prompts.map((prompt) => (
          <div
            key={prompt}
            className="flex items-center gap-1 rounded-lg border border-border/50 px-3 py-2.5 transition-colors hover:border-primary/50 hover:bg-muted"
          >
            <button
              type="button"
              onClick={() => onSelect(prompt)}
              className="flex-1 text-left text-xs text-foreground"
            >
              {prompt}
            </button>
            {onRefine && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); onRefine(prompt); }}
                className="shrink-0 rounded-full p-1 text-muted-foreground/50 hover:text-primary transition-colors"
                aria-label="Refinar este prompt antes de enviar"
              >
                <Wand2 className="h-3 w-3" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
